import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {IOption} from 'ng-select';
declare  const $;
import {Popup} from 'ng2-opd-popup';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import * as moment from 'moment/moment';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';

@Component({
  selector: 'app-labour-cost',
  templateUrl: './labour-cost.component.html',
  styleUrls: ['./labour-cost.component.scss']
})

export class LabourCostComponent implements OnInit {
	ToolTip="Delete is not allowed since it is used in contract registration page";
	labourCostfromPreventiveMaintainance=[];
	servicetypeedit:any="SELECT A SERVICE TYPE"
	makeedit:any="SELECT A MAKE";
	modeledit:any="SELECT A MODEL";
	myFormsOptions: Array<IOption> = []
	myFormsOptionsModel:Array<IOption>=[];
	myFormsOptionServiceType:Array<IOption>=[]
	loading:boolean=true;
	ListMakeDetails:any[] = [];
	ListOflabourDetails:any[] = [];
	AllowModel:boolean=true;
	msgtext:any;
	btnName='Submit';
	isValid:boolean=true;
	newMake_err:boolean=false;
	newModel_err:boolean=false;
	labourcost_err:boolean=false;
	labourhours_err:boolean=false;
	labourhour:any="";
	make:any;
	model:any;
	labourCost:any;
	EditObjectId:any;
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	@ViewChild('addLabour') addLabour: Popup;
 	@ViewChild('update') update: Popup;
	@ViewChild('Askdelete') Askdelete: Popup;
	@ViewChild('deletepop') deletepop: Popup;
	@ViewChild('duplicate') duplicate: Popup;
	deleteId:any;
	ListserviceTypeDetails:any[] = [];
	servicetype:any;
	servicetype_err:boolean=false;
	ListModelDetails:any[] = [];
	ListAllModelDetails:any[] = [];
	jsonmake:any;
	jsonmakeId:any;
	jsonmodel:any;
	jsonmodelId:any;
	jsonservicetype:any;
	jsonservicetypeId:any;
	orgId:number;
	userId:number;
	TotalLabourCost:number;
	duplicateMessage:string = 'This LabourCost Already Exists';
	isLabourListLoaded:boolean = false;
	isDeleteAvailabilityLoaded:boolean = false;
	constructor(private dialogService:DialogService,private router:Router,private route : ActivatedRoute,private http: Http,private toastyService:ToastyService,private toastyConfig: ToastyConfig) { }

	ngOnInit() {
		this.loading=true;
		this.isLabourListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
		
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
		this.getAllMakedetails();
		
	}


	getAllPreventiveMaintenanceDetails() {
		
		let reqPMSObj = {
		  'orgId':this.orgId
		}
		return this.http.post('/api/getAllPreventiveMaintenanceDetails',reqPMSObj).subscribe(
		 	res => {
			let Response = res.json();
			let pusharr=[]
			let makepush="";
			let modelpush="";
			if(Response.length>0){
				for(let j=0;j<Response.length;j++){
					for(let i=0;i<this.ListMakeDetails.length;i++){
						if(this.ListMakeDetails[i]._id==Response[j].make){
							makepush= this.ListMakeDetails[i].make
						}
			 		}
					for(let k=0;k<this.ListAllModelDetails.length;k++){
						if(this.ListAllModelDetails[k]._id==Response[j].model){
							modelpush=this.ListAllModelDetails[k].model
						}

			 		}
					pusharr.push({"make":makepush,"model":modelpush})
		 		}
				this.labourCostfromPreventiveMaintainance=pusharr;
				this.CheckToolTIp();
			}else{
				this.loading=false;
			}
	
		  },(err)=>{
		   
		  })
	  }

		
		CheckToolTIp(){
			if(this.ListMakeDetails.length==0||		this.ListMakeDetails.length==undefined){
				this.getAllMakedetails();
			}else if(this.labourCostfromPreventiveMaintainance.length==0||this.labourCostfromPreventiveMaintainance==undefined){
				this.getAllPreventiveMaintenanceDetails();
			}else{
				for(let i=0;i<this.ListOflabourDetails.length;i++){
					for(let j=0;j<this.labourCostfromPreventiveMaintainance.length;j++){
			   	if(this.ListOflabourDetails[i].make==this.labourCostfromPreventiveMaintainance[j].make&&this.ListOflabourDetails[i].model==this.labourCostfromPreventiveMaintainance[j].model){
					this.ListOflabourDetails[i].status=true
				}
				}
			}
			this.loading=false;
			}


     
		}

	getlabourhoursdetails() {
    	if(this.labourhour == null || this.labourhour == "" || this.labourhour == undefined) {
    		this.labourhours_err=true;
				this.isValid=false;
				
    	} else {
    		this.labourhours_err=false;
    		this.isValid=true;
    	}
    }

  showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"ADD LABOURCOST",message:"The Data added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"UPDATE LABOURCOST",message:"The Data updated successfully"});
	}
	showAlertForDeletingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"DELETE LABOURCOST",message:"The Data deleted successfully"});
	}

	showDuplicatePopup(message) {
		this.duplicateMessage = message;
		this.duplicate.options = {
	        showButtons: false,
	        color: "#4180ab",
	        header: "Labour Cost"
	    };
	    this.duplicate.show(this.duplicate.options);
	}
	 addOk() {
		this.addLabour.hide();
	}

	updateOk() {
		this.update.hide();
	}

	deleteOk() {
		this.deletepop.hide();
	}

	duplicateOk() {
		this.duplicate.hide();
	}

	updateLoadingState() {
		this.loading = !(this.isLabourListLoaded && this.isDeleteAvailabilityLoaded);
	}

	getAllMakedetails () {
		let makeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getMakedetails',makeObj).subscribe(
	    res => {
				
			let ResponeMake = res.json();
	
			this.ListMakeDetails = res.json();
			if(this.ListMakeDetails.length>0) {
				let a=[];
				for(let i=0 ;i<this.ListMakeDetails.length;i++){
					a.push({'value':this.ListMakeDetails[i]._id.toString(),'label':this.ListMakeDetails[i].make.toUpperCase()});
				}
				this.myFormsOptions=a;
				this.getAllModelDetails();
			} else {
                this.loading=false;
			}
			
								
	        
	    },(err) =>{
				
				this.loading=false;
	      this.getAllModelDetails();
	      if(err.status != 200){
	        this.msgtext = "Unable to load the make Value";
	        this.getWarningFunction(this.msgtext);
	      }
	    })
  	}

  	getAllModelDetails () {
		let modelObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getAllModeldetails', modelObj).subscribe(
	    res => {
	        let ServiceResponse =res.json();
			this.ListAllModelDetails = res.json();
			if(this.ListAllModelDetails.length>0) {
				this.getAllServiceDetails ();
			} else {
                this.loading=false;
			}
				// this.loading=false;
	        
	    },(err) =>{
			this.loading=false;
			this.getAllServiceDetails ();
			if(err.status != 200){
	          this.msgtext = "Unable to load the model Value";
	          this.getWarningFunction(this.msgtext);
	        }
	    })
	}

  	getAllServiceDetails () {
		let serviceTypeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getServiceTypedetails',serviceTypeObj).subscribe(
	    res => {
	        let ServiceResponse =res.json();
			this.ListserviceTypeDetails = res.json();
			if(this.ListserviceTypeDetails.length>0) {
			
				let a=[];
				for(let i=0 ;i<this.ListserviceTypeDetails.length;i++){
					a.push({'value':this.ListserviceTypeDetails[i]._id.toString(),'label':this.ListserviceTypeDetails[i].servicetype.toUpperCase()});
				}
				this.myFormsOptionServiceType=a;
				
				this.getAllDetailsFromLabourCost ();
			} else {
				this.loading=false;
			}
			
	    },(err) =>{
			this.getAllDetailsFromLabourCost ();
					//this.spinner.hide();
					this.loading=false;
	        if(err.status != 200){
	          this.msgtext = "Unable to load the service type Value";
	          this.getWarningFunction(this.msgtext);
	        }
    })
  }

	

  	getCount(){
	   if(this.p < Math.ceil(this.ListMakeDetails.length/10)){
	     this.startingCount = (this.p-1)*10;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	     }
	     this.endingCount = this.p*10;
	   } else if(this.p == Math.ceil(this.ListMakeDetails.length/10)){
	     let count = this.ListMakeDetails.length%10;
	     this.startingCount = (this.p-1)*10;
	     this.endingCount = this.startingCount + count;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	       this.endingCount = count;
	     }
	   }
	  }

  	_keyPress(event: any) {
	    const pattern = /[0-9\.\ ]/;
	    let inputChar = String.fromCharCode(event.charCode);

	    if (!pattern.test(inputChar)) {
	      // invalid character, prevent input
	      event.preventDefault();
	    }
	}

  	getAllDetailsFromLabourCost () {
		this.loading=true;
		this.isLabourListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
  		let labourCostObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getLabourCostdetails', labourCostObj).subscribe(
	    res => {
	    	this.ListOflabourDetails = [];
			let labourresponse = res.json();
		
	     	if(labourresponse.length>0) {
	     		for(let lb=0;lb<labourresponse.length;lb++) {
	     			for(let i=0;i<this.ListMakeDetails.length;i++) {
		     			if(this.ListMakeDetails[i]._id == labourresponse[lb].makeId) {
		     				this.jsonmake = this.ListMakeDetails[i].make;
		     				this.jsonmakeId = labourresponse[lb].makeId;
		     			}
		     		}
		     		for(let md=0;md<this.ListAllModelDetails.length;md++) {
		     			if(this.ListAllModelDetails[md]._id == parseInt(labourresponse[lb].modelId)) {
		     				this.jsonmodel = this.ListAllModelDetails[md].model;
		     				this.jsonmodelId = labourresponse[lb].modelId;
		     			}
		     		}
		     		for(let st=0;st<this.ListserviceTypeDetails.length;st++) {
		     			if(this.ListserviceTypeDetails[st]._id == parseInt(labourresponse[lb].serviceType)) {
		     				this.jsonservicetype = this.ListserviceTypeDetails[st].servicetype;
		     				this.jsonservicetypeId = labourresponse[lb].serviceType;
		     			}
		     		}
		     		let reqobj = {
		     			'make':this.jsonmake,
		     			'makeId':this.jsonmakeId,
		     			'model':this.jsonmodel,
		     			'modelID':this.jsonmodelId,
		     			'serviceType':this.jsonservicetype,
		     			'serviceTypeId':this.jsonservicetypeId,
						'labourCost':labourresponse[lb].labourCost,
						'labourhour':labourresponse[lb].labourhours,
						'totalLabourCost':labourresponse[lb].totalLabourCost,
						'ID':labourresponse[lb]._id,
						'status':false
		     		}
		     		this.ListOflabourDetails.push(reqobj);
	     		}
	    		this.isLabourListLoaded = true;
	    		this.loadDeleteAvailability();
			 }else{
				 this.isLabourListLoaded = true;
				 this.isDeleteAvailabilityLoaded = true;
				 this.updateLoadingState();
			 }
		
	    },(err) =>{
				this.isLabourListLoaded = true;
				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
	      this.getCount();
	      if(err.status != 200){
	        this.msgtext = "Unable to load the labour cost Value";
	        this.getWarningFunction(this.msgtext);
	      }
	    })
	}

	loadDeleteAvailability() {
		let labourIds = [];

		for(let i=0;i<this.ListOflabourDetails.length;i++) {
			this.ListOflabourDetails[i].status = false;
			this.ListOflabourDetails[i].deleteBlockedReason = '';
			labourIds.push(this.ListOflabourDetails[i].ID);
		}

		return this.http.post('/api/getLabourCostDeleteAvailability', {
			'ids':labourIds,
			'orgId':this.orgId
		}).subscribe(
			res => {
				let availabilityResponse = res.json().availability || {};

				for(let i=0;i<this.ListOflabourDetails.length;i++) {
					if(availabilityResponse[String(this.ListOflabourDetails[i].ID)] && availabilityResponse[String(this.ListOflabourDetails[i].ID)].canDelete === false) {
						this.ListOflabourDetails[i].status = true;
						this.ListOflabourDetails[i].deleteBlockedReason = availabilityResponse[String(this.ListOflabourDetails[i].ID)].reason || this.ToolTip;
					}
				}

				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
			},(err) => {
				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
				if(err.status != 200){
					this.msgtext = "Unable to validate delete availability";
					this.getWarningFunction(this.msgtext);
				}
			}
		)
	}

	getMakedetails() {
		if(this.make == "" || this.make == undefined || this.make == null) {
			this.newMake_err=true;
			this.isValid=false;
		this.AllowModel=true;
			this.ListModelDetails=[];
		} else {
			this.getmodalValueBasedOnMakeId();
			this.newMake_err=false;
			this.isValid=true;
			this.AllowModel=false;
		}
	}

	Inputlabour() {
		if(this.labourCost == "" || this.labourCost == undefined || this.labourCost == null) {
			this.labourcost_err=true;
			this.isValid=false;
		} else {
			this.labourcost_err=false;
			this.isValid=true;
		}
	}

	getModeldetails() {
		if(this.make == "" || this.make == undefined || this.make == null) {
			alert('please select Make');
			this.model="";
		}
		if(this.model == "" || this.model == null || this.model == undefined) {
			this.newModel_err = true;
			this.isValid=false;
		} else {
			this.newModel_err = false;
			this.isValid=true;
		}
	}

	getserviceTypedetails() {
		if(this.servicetype == "" || this.servicetype == null || this.servicetype == undefined) {
			this.servicetype_err = true;
			this.isValid=false;
		} else {
			this.servicetype_err = false;
			this.isValid=true;
		}
	}


	getmodalValueBasedOnMakeId() {
		let reqModelObj = {
			'MakeId':this.make,
			'orgId':this.orgId
	      }
	      return this.http.post('/api/getModeldetailsBasedOnMakeID', reqModelObj).subscribe(
	      res => {
	      	this.ListModelDetails = [];
				 
			this.loading=false;
			let ResponeModel = res.json();
			this.ListModelDetails = res.json();
				
			let b=[];
			for(let i=0;i<this.ListModelDetails.length;i++){
					b.push({'value':this.ListModelDetails[i]._id.toString(),'label':this.ListModelDetails[i].model.toUpperCase()});
			}
			this.myFormsOptionsModel=b;
		
				
	      },(err) =>{
	        if(err.status != 200){
	          this.msgtext = "Unable to load the Value";
	          this.getWarningFunction(this.msgtext);
	        }
	      })
	  }

	Empty() {
		this.make="";
		this.model="";
		this.labourCost="";
		this.labourhour="";
		this.labourhours_err=false;
		this.newMake_err = false;
		this.newModel_err = false;
		this.labourcost_err = false;
		this.isValid=true;
		this.btnName='Submit';
		this.EditObjectId = "";
		this.servicetype = "" ;
		this.servicetype_err = false;
		this.AllowModel=true;
		this.ListModelDetails=[];
		this.makeedit="SELECT A MAKE";
		this.modeledit="SELECT A MODEL";
		this.servicetypeedit="SELECT A SERVICE TYPE";
	}

	reset() {
		this.Empty();
	}



	addlabourdetails() {
	   this.loading=true;
	    if(this.make == "" || this.make == undefined || this.make == null) {
	        this.newMake_err = true;
			this.loading=false;
	        document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
	    } else if(this.model == "" || this.model == undefined || this.model == null) {
		    this.newModel_err = true;
			 this.loading=false;
		    document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
	    } else if(this.labourCost == "" || this.labourCost == undefined || this.labourCost == null||/^\s*$/.test(this.labourCost)) {
			this.labourcost_err = true;
			this.loading=false;
	        document.body.scrollTop = 0;
       		document.documentElement.scrollTop = 0;
	    } else if(this.servicetype == "" || this.servicetype == null || this.servicetype == undefined) {
	    	this.servicetype_err = true;
			this.loading=false;
	    	document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
	    }else if(this.labourhour==""||this.labourhour==undefined||this.labourhour==null||/^\s*$/.test(this.labourhour)){
			this.labourhours_err = true;
			this.loading=false;
	    	document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
		} else{
	    	if(this.EditObjectId == "" || this.EditObjectId == undefined || this.EditObjectId == null) {
	    		// Frontend duplicate check before calling API
	    		let isDuplicate = false;
	    		for(let i = 0; i < this.ListOflabourDetails.length; i++) {
	    			if(String(this.ListOflabourDetails[i].makeId) == String(this.make) &&
	    			   String(this.ListOflabourDetails[i].modelID) == String(this.model) &&
	    			   String(this.ListOflabourDetails[i].serviceTypeId) == String(this.servicetype)) {
	    				isDuplicate = true;
	    				break;
	    			}
	    		}
	    		if(isDuplicate) {
	    			this.loading = false;
	    			this.showDuplicatePopup('This LabourCost Already Exists');
	    			return false;
	    		}
	    		let reqModelObj = {
		            'make':this.make,
		            'model':this.model,
					'labourcost':this.labourCost,
					'totalLabourCost':(this.labourCost*this.labourhour).toFixed(2),
					'labourhours':this.labourhour,
		            'serviceType':this.servicetype,
		            'orgId':this.orgId,
			        'created_By':this.userId,
			        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
		        }
		        return this.http.post('/api/addlabourcostValue', reqModelObj).subscribe(
		        res => {
		          	let modelResponse = res.json();
		          	if(modelResponse.message == 'This LabourCost Already Exists') {
						this.loading=false;
		            	this.showDuplicatePopup('This LabourCost Already Exists');
		          	} else {
		            	this.loading=false;
				        document.body.scrollTop = 0;
			        	document.documentElement.scrollTop = 0;
				      	this.showAlertForAddingdata();
				        this.Empty();
				        this.getAllDetailsFromLabourCost ();
		          	}
		        },(err) =>{
						this.loading=false;
				        if(err.status != 200){
				            this.msgtext = "Unable to load the Value";
				            this.getWarningFunction(this.msgtext);
				        }
		        })	
	    	} else {
	    		// Frontend duplicate check for update (skip the row being edited)
	    		let isDuplicateEdit = false;
	    		for(let i = 0; i < this.ListOflabourDetails.length; i++) {
	    			if(String(this.ListOflabourDetails[i].ID) != String(this.EditObjectId) &&
	    			   String(this.ListOflabourDetails[i].makeId) == String(this.make) &&
	    			   String(this.ListOflabourDetails[i].modelID) == String(this.model) &&
	    			   String(this.ListOflabourDetails[i].serviceTypeId) == String(this.servicetype)) {
	    				isDuplicateEdit = true;
	    				break;
	    			}
	    		}
	    		if(isDuplicateEdit) {
	    			this.loading = false;
	    			this.showDuplicatePopup('This LabourCost Already Exists');
	    			return false;
	    		}
	    		let reqModelObj = {
		          	'make':this.make,
		          	'model':this.model,
					'labourcost':this.labourCost,
					'labourhours':this.labourhour,
					'totalLabourCost':(this.labourCost*this.labourhour).toFixed(2),
		          	'objectId':this.EditObjectId,
		          	'serviceType':this.servicetype,
		            'orgId':this.orgId,
			        'updated_By':this.userId,
			        'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
		        }
		        return this.http.post('/api/UpdatelabourCostdetails', reqModelObj).subscribe(
		        res => {
		          let modelResponse = res.json();
		          if(modelResponse.message == 'This LabourCost Already Exists') {
							 this.loading=false;
		            this.showDuplicatePopup('This LabourCost Already Exists');
		          } else {
		            	this.loading=false;
				        document.body.scrollTop = 0;
			        	document.documentElement.scrollTop = 0;
				    	this.showAlertForUpdatingdata();
				        this.Empty();
				        this.getAllDetailsFromLabourCost ();
		            }
		        },(err) =>{
							this.loading=false;
		          if(err.status != 200){
		            this.msgtext = "Unable to load the Value";
		            this.getWarningFunction(this.msgtext);
		          }
		        })
	    	}
	        
	    }
	}

 
//

	Editing(index, ObjectId) {
		document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
		this.EditObjectId=ObjectId;
		this.btnName='Update';
		
		//this.getmodalValueBasedOnMakeId();
		for(let i=0;i<this.ListOflabourDetails.length;i++){
			if(this.ListOflabourDetails[i].ID==ObjectId){
				this.make = this.ListOflabourDetails[i].makeId.toString();
				this.makeedit=this.ListOflabourDetails[i].make.toUpperCase();
			}
		}
		let reqModelObj = {
			'MakeId':this.make,
			'orgId':this.orgId
	      }
	      return this.http.post('/api/getModeldetailsBasedOnMakeID', reqModelObj).subscribe(
	      res => {
	      	this.ListModelDetails = [];
			this.loading=false;
	        let ResponeModel = res.json();
			this.ListModelDetails = res.json();
			let b=[];
			for(let i=0;i<this.ListModelDetails.length;i++){
					b.push({'value':this.ListModelDetails[i]._id.toString(),'label':this.ListModelDetails[i].model.toUpperCase()});
			}
			this.myFormsOptionsModel=b;
			this.AllowModel=false;
			
		
		
				for(let i=0;i<this.ListOflabourDetails.length;i++){
			if(this.ListOflabourDetails[i].ID==ObjectId){
				this.labourCost = this.ListOflabourDetails[i].labourCost;
				this.labourhour=this.ListOflabourDetails[i].labourhour;
				this.servicetype = this.ListOflabourDetails[i].serviceTypeId.toString();
				this.servicetypeedit=this.ListOflabourDetails[i].serviceType.toUpperCase();

				this.model = this.ListOflabourDetails[i].modelID.toString();
				this.modeledit=this.ListOflabourDetails[i].model.toUpperCase();

			}
		}
			},(err) =>{
	        if(err.status != 200){
	          this.msgtext = "Unable to load the Value";
	          this.getWarningFunction(this.msgtext);
	        }
	      })
		
	}

	Delete(index, deleteId, labourRow?) {
		document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
		if(labourRow && labourRow.status === true) {
			this.msgtext = labourRow.deleteBlockedReason || this.ToolTip;
			this.getWarningFunction(this.msgtext);
			return false;
		}
		this.Empty();
		this.deleteId = deleteId;
		this.Askdelete.options = {
	        showButtons: false, // You can hide this in case you want to use custom 
	        color: "#4180ab",
	        header: "Delete LabourCost"
	    };
	    this.Askdelete.show(this.Askdelete.options);
	}

	No() {
		this.Askdelete.hide();
	}

	Yes() {
		this.Askdelete.hide();
		this.loading=true;
		let reqModelObj = {
	        'deleteId':this.deleteId,
	        'orgId':this.orgId
	    }
	    return this.http.post('/api/deletelabourCostDetails', reqModelObj).subscribe(
	      res => {
	        let modelResponse = res.json();
				if(modelResponse && modelResponse.canDelete === false) {
					this.loading=false;
					this.msgtext = modelResponse.reason || this.ToolTip;
					this.getWarningFunction(this.msgtext);
					this.getAllDetailsFromLabourCost();
					return false;
				}
				this.loading=false;
	        // this.deletepop.options = {
		    //     showButtons: false, // You can hide this in case you want to use custom 
		    //     color: "#4180ab",
		    //     header: "LabourCost Deleted"
		    // };
			// this.deletepop.show(this.deletepop.options);
			this.showAlertForDeletingdata();
		    this.deleteId="";
		    this.Empty();
	        this.getAllDetailsFromLabourCost();
	        
	    },(err)=>{
			this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}

	deletesuccessOk() {
		this.deletepop.hide();
	}

  	getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "Make",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	    };
        this.toastyService.warning(toastOptions);
    }//getWarningFunction end here


	getSuccessFunction(successMsg){
	    var toastOptions:ToastOptions = {
	      title: "Make",
	      msg: successMsg,
	      showClose: true,
	      timeout: 3000,
	      theme: 'bootstrap',
	      onAdd: (toast:ToastData) => {
	      },
	      onRemove: function(toast:ToastData) {
	      }
	    };
	    this.toastyService.success(toastOptions);
	}//getSuccessFunction end here
}


// WEBPACK FOOTER //
// ./client/app/labour-cost/labour-cost.component.ts